
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { CloseButton, ETitle, Modal } from '../../../components/ui'
import { useModal } from '../../../context/ModalProvider'
import { MODE } from '../../../data/queryFactories'
import { Button } from '../../../components/ui/legacy'
import { Icon } from '@iconify/react'
import FormField from '../../../components/function/form/FormField'

const bookPackageFormSchema = z.object({
  name: z.string().min(1, {message: 'Tên gói sách không được để trống'}),
  description: z.string().optional().nullable(), 
})
export default function BookPackageFormModal({ mode, initForm, submitHandler, isLoading }) {
  const {  handleCloseModal } = useModal()

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(bookPackageFormSchema),
    defaultValues: initForm,
  })
  const onSubmit = (formData) => {  
    const transFormData={
      name:formData.name,
      description:formData.name
    } 
    submitHandler(transFormData)
  }
  const textFieldCreateData = [
    {
      label: 'Tên gói sách',
      type: 'text',
      name: 'name',
      placeholder: 'Tên (tối đa 255 ký tự)',
      length: 255,
      required: true,
      disabled: false,
    },
  ]
  const title = `${mode === MODE.CREATE ? 'Tạo' : 'Cập nhật'} gói sách`
  return (
    <Modal
      onClose={() => {
        handleCloseModal()
      }}
      className="w-[55vw] rounded-md bg-white p-8 text-gray-accent"
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
          }
        }}
      >
        <header className="relative w-full">
          <ETitle text={title} />
          <CloseButton
            className="absolute right-0 top-0"
            onClickHandler={() => {
              handleCloseModal()
            }}
          />
        </header>
        <div className="mt-4">
          {textFieldCreateData.map((field) => (
            <FormField
              key={field.name}
              {...field}
              register={register}
              errors={errors}
              control={control}
              placeholder={field?.placeholder}
              options={field?.options}
              size={field?.length}
            />
          ))}
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            disabled={Object.keys(errors).length > 0 || isLoading}
            variant={'primary'}
            type="submit"

          >
            <Icon
              icon="ph:folder-simple-plus"
              width="1.5rem"
              className="aspect-square text-[white]"
            />
            <p className="pl-2 text-white">
              {isLoading ? 'Đang xử lý...' : title}
            </p>
          </Button>
        </div>
      </form>
    </Modal>
  )
}